import React, { useEffect, useRef, useState } from "react";
import { Stage, Layer, Image as KonvaImage, Line } from "react-konva";

const ImageViewer = ({ imageUrl, detection = null }) => {
  const [image, setImage] = useState(null);
  const [stageProps, setStageProps] = useState({
    x: 0,
    y: 0,
    scale: 1,
  });

  const stageRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const img = new window.Image();
    img.src = imageUrl.path;
    img.onload = () => {
      setImage(img);
    };
  }, [imageUrl]);

  useEffect(() => {
    if (image && containerRef.current) {
      const container = containerRef.current;
      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;
      const scale = containerHeight / image.height;
      const offsetX = (containerWidth - image.width * scale) / 2;

      setStageProps({
        scale: scale,
        x: offsetX,
        y: 0, 
      });
    }
  }, [image]);

  const handleWheel = (e) => {
    e.evt.preventDefault();
    const stage = stageRef.current;
    if (!stage) return;

    const oldScale = stage.scaleX();
    const pointer = stage.getPointerPosition();

    const mousePointTo = {
      x: (pointer.x - stage.x()) / oldScale,
      y: (pointer.y - stage.y()) / oldScale,
    };

    const scaleBy = 1.1;
    const newScale = e.evt.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;

    setStageProps({
      scale: newScale,
      x: pointer.x - mousePointTo.x * newScale,
      y: pointer.y - mousePointTo.y * newScale,
    });
  };

  const handleDragEnd = (e) => {
    setStageProps({
      ...stageProps,
      x: e.target.x(),
      y: e.target.y(),
    });
  };

  return (
    <div ref={containerRef} style={{ width: "100%", height: "100%", cursor: "grab" }}>
      <Stage
        width={containerRef.current?.clientWidth || 0}
        height={containerRef.current?.clientHeight || 0}
        style={{ background: "#1a1a1a" }}
        draggable
        onWheel={handleWheel}
        onDragEnd={handleDragEnd}
        ref={stageRef}
        x={stageProps.x}
        y={stageProps.y}
        scaleX={stageProps.scale}
        scaleY={stageProps.scale}
      >
        <Layer>
          {image && (
            <>
              <KonvaImage image={image} />
              {detection && (
                <Line
                  points={[
                    detection.x1 * image.width, detection.y1 * image.height,
                    detection.x2 * image.width, detection.y2 * image.height,
                    detection.x3 * image.width, detection.y3 * image.height,
                    detection.x4 * image.width, detection.y4 * image.height,
                  ]}
                  closed={true}
                  stroke={detection.objectTypeId === "HOTSPOT" ? "#00FF00" : "cyan"}
                  strokeWidth={4 / stageProps.scale}
                />
              )}
            </>
          )}
        </Layer>
      </Stage>
    </div>
  );
};

export default ImageViewer;